export const getCategoryIdFromHash = (): number | undefined => {
	const match = window.location.hash.match(/#category\/(\d+)/);
	if (match) {
		const id = parseInt(match[1]);
		if (!isNaN(id)) return id;
	}
};

export default getCategoryIdFromHash;
